import { Col, Row, Typography } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import { useMemo, VFC } from 'react'

type ArtistGroup = {
  [key: string]: ArtistNameType[]
}

type Props = {
  artists: ArtistNameType[]
}

export const ArtistList: VFC<Props> = ({ artists }) => {
  const { xs } = useBreakpoint()

  const firstAlphabet = (name?: string) => {
    if (!name) return null

    const isAlphabet = /^[a-z]$/i.test(name[0])
    return isAlphabet ? name[0] : null
  }

  const artistGroup = useMemo(
    () =>
      artists?.reduce((groups, artist) => {
        const initialCharacter =
          firstAlphabet(artist?.name_en) || firstAlphabet(artist?.name)
        const key = initialCharacter ? initialCharacter.toUpperCase() : 'Others'
        if (!groups[key]) {
          groups[key] = []
        }
        groups[key].push(artist)
        return groups
      }, {} as ArtistGroup),
    [artists],
  )

  // Convert the object to entries, sort them, and convert it to an object array
  const artistGroups = useMemo(() => {
    if (!artistGroup) return []
    const sortedEntries = Object.entries(artistGroup).sort(([keyA], [keyB]) => {
      if (keyA === 'Others') return 1
      if (keyB === 'Others') return -1
      return keyA.localeCompare(keyB)
    })
    return sortedEntries.map(([key, value]) => ({ [key]: value }))
  }, [artistGroup])

  return (
    <Row>
      {[...Array(xs ? 2 : 4)].map((_, i) => {
        return (
          <Col
            xs={12}
            md={6}
            key={`lane-${i}`}
            style={{ display: 'flex', flexDirection: 'column', gap: 32 }}
          >
            {artistGroups
              .filter((_artistGroup, index) => index % (xs ? 2 : 4) === i)
              .map((artistGroup) => {
                const initialCharacter = Object.keys(artistGroup)[0]
                const artists = Object.values(artistGroup)[0]
                return (
                  <div
                    key={Object.keys(artistGroup)[0]}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-start',
                      gap: 16,
                    }}
                  >
                    <Typography.Title key={initialCharacter}>
                      {initialCharacter}
                    </Typography.Title>
                    {artists.map((artist) => (
                      <Typography.Text key={artist.id}>
                        {artist.name_en || artist.name}
                      </Typography.Text>
                    ))}
                  </div>
                )
              })}
          </Col>
        )
      })}
    </Row>
  )
}
